<template>
    <div>
        <template v-if="list.length">
            <div class="patient-info" v-for="(item, index) in list" :key="item.id" v-watermark>
                <div class="patient-info-header">
                    <div class="left">
                        <span class="name">{{ item.memberName }}</span>
                        <span style="margin-left: 10px">
                            {{ item.memberSex | sexFilter(item.memberSex)  }} | {{ item.memberAge + '岁' }} | {{ item.memberMobile }}
                        </span>
                    </div>
                </div>
                <div class="patient-info-content">
                    <div class="cells">
                        <div class="cell full">
                            <span class="label">会诊医生</span>
                            <span>{{ item.consultationDoctorName || "" }}</span>
                        </div>
                        <div class="cell full">
                            <span class="label">申请人</span>
                            <span>{{ item.applyDoctorName || "" }}</span>
                        </div>
                        <div class="cell full">
                            <span class="label">申请时间</span>
                            <span style="">{{ item.applyTime || '' }}</span>
                        </div>
                    </div>
                </div>
                <div class="patient-info-footer">
                    <div class="follow-up" @click="cancelApply(item.consultationNo)" v-if="item.state == 0">取消</div>
                    <div class="inquiry" @click="toApplyPay(item.consultationNo)" v-if="item.state == 0">会诊订单支付</div>
                    <div class="more" @click="checkRecord(item.consultationNo)">查看会诊</div>
                </div>
            </div>
            <div class="pagination" v-if="total > pageSize">
                <van-pagination v-model="pageNo" :total-items="total" :items-per-page="pageSize" @change="pageChange">
                    <template #prev-text>
                        <van-icon name="arrow-left" />
                    </template>
                    <template #next-text>
                        <van-icon name="arrow" />
                    </template>
                    <template #page="{ text }">{{ text }}</template>
                </van-pagination>
            </div>
        </template>
        <van-empty description="暂无数据" v-else />
        <receive-coupon :show.sync="receiveCouponState.show" :userNo="receiveCouponState.userNo" />
    </div>
</template>
<script>
import request from '@/utils/request.js'
import askStatus from '@/components/ask/status.vue'
import vip from '@/components/vip/index.vue'
import VipChannel from '@/components/vip/channel.vue'
import ReceiveCoupon from '@/components/coupon/receiveCoupon.vue'
import { Dialog } from 'vant';
export default {
    components: {
        askStatus,
        vip,
        ReceiveCoupon,
        VipChannel
    },
    props: {
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 5
        },
        list: {
            type: Array
        },
        showTag: Boolean
    },
    watch: {
        currentPage(val) {
            this.pageNo = val
        }
    },
    data() {
        return {
            pageNo: 1,
            relation: {
                show: [],
                submit: true
            },
            receiveCouponState: {
                show: false,
                userNo: null,
            },
        }
    },
    methods: {
        pageChange(val) {
            this.$emit('pageChange', val)
        },
        cancelApply(consultationNo) {
            Dialog.confirm({
                title: '提示',
                message: '是否取消该会诊',
            })
            .then(() => {
                request({
                    url: `/doctor-service/doctorConsultation/cancel/${consultationNo}`,
                    method: 'post',
                }).then(() => {
                    this.$toast.success('已取消');
                    this.$emit('init');
                }).catch(() => {
                    
                })
            })
            .catch(() => {
                // on cancel
            });
        },
        checkRecord(no) {
            this.$router.push({
                path: '/consultation/record',
                query: {
                    no: no
                }
            })
        },
        toApplyPay(no) {
            this.$router.push({
                path: '/consultation/pay',
                query: {
                    no: no
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.patient-info {
    margin-top: 10px;
    background: #fff;
    border-radius: 4px;

    .patient-info-header {
        padding: 22px 26px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            display: flex;
            align-items: center;

            .name {
                font-size: 18px;
                font-weight: bold;
            }
        }

        .right {
            display: flex;

            .coupon,
            .call {
                color: #0082EF;
                background: #f5f5f5;
                padding: 6px 14px;
                margin: 0;
                text-align: center;
                width: 80px;
                font-weight: bold;
                font-size: 16px;
                height: 40px;
                border: none;
            }

            .call {
                color: #0FBC54;
                margin-right: 10px;
            }
        }


    }

    .patient-info-content {
        padding: 0px 26px;

        .cells {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;

            .cell {
                width: 50%;
                display: flex;
                margin-bottom: 14px;

                &.full {
                    width: 100%;
                }

                .label {
                    flex: none;
                    margin-right: 20px;
                    color: #999;
                }
            }
        }
    }

    .van-col {
        font-size: 14px;
        margin-bottom: 14px;

        span {
            &:first-child {
                color: #999;
                margin-right: 20px;
            }
        }
    }

    .patient-info-footer {
        padding: 18px 0;
        background: #F6FBFF;
        display: flex;
        font-size: 16px;
        flex-wrap: wrap;

        div {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            flex: 1;
        }

        .follow-up {
            color: #F59A23;
            border-right: 1px solid #E1E8EF;
        }

        .inquiry {
            color: #0082EF;
            border-right: 1px solid #E1E8EF;
        }

        .medicated {
            color: #ff6e4a;
            border-right: 1px solid #E1E8EF;
        }

        .tracking {
            color: #6764FF;
            border-right: 1px solid #E1E8EF;
        }

        .createAsk {
            color: #3399ff;
            border-right: 1px solid #E1E8EF;
        }

        .more {
            color: #0FBC54;
        }
    }
}

.pagination {
    padding: 20px 0;
}

.relation {
    margin-left: 10px;
}

.relation-list {
    padding: 5px;

    .itm {
        margin-top: 5px;

        &:first-child {
            margin-top: 0;
        }

        .van-button {
            padding: 5px 10px;
        }
    }
}

.vip-equity {
    margin-bottom: 15px;
}
</style>